import TrueDiscMeta from "../content/true-disc/meta.json";
import GmAiUiMeta from "../content/gm-ai-ui/meta.json";
import ShoeboxMeta from "../content/shoebox/meta.json";
import MitchKitchMeta from "../content/mitch-kitch/meta.json";
import RapidIterationUtilitiesMeta from "../content/rapid-iteration-utilities/meta.json";

const caseStudies = [
  {
    ...TrueDiscMeta,
    component: () => import("../content/true-disc/index.mdx"),
  },
  {
    ...GmAiUiMeta,
    component: () => import("../content/gm-ai-ui/index.mdx"),
  },
  {
    ...ShoeboxMeta,
    component: () => import("../content/shoebox/index.mdx"),
  },
  {
    ...MitchKitchMeta,
    component: () => import("../content/mitch-kitch/index.mdx"),
  },
  {
    ...RapidIterationUtilitiesMeta,
    component: () => import("../content/rapid-iteration-utilities/index.mdx"),
  },
];

export default caseStudies;
